import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { BenefitType, Box, Notification, NotificationType } from 'edenred-ui';

import { PaymentMethods } from '@epi-constants/paymentMethods';
import { Payment, Schedule } from '@epi-constants/benefitTypes';
import { getAnyDeferredCardOrders } from '@epi-selectors/settings';
import { FormFields } from '@epi-forms/helpers';
import { IBenefits } from '@epi-models/containers/ManageBenefits';

import { SemiBold } from '../TopupConfirmationModal/TopupConfirmationModal.styles';

interface TopupFormNotificationsProps {
  isLunchTopupRequest: boolean;
  benefitType?: IBenefits;
}

export const TopupFormNotifications = ({
  isLunchTopupRequest,
  benefitType
}: TopupFormNotificationsProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const anyDeferredCardOrders = useSelector(getAnyDeferredCardOrders);
  const paymentMethod = watch(FormFields.PaymentMethod);
  const scheduleType = watch(FormFields.ScheduleType);

  return (
    <>
      {paymentMethod === PaymentMethods.PdfInvoice && (
        <Box mt={2}>
          <Notification
            id="email-invoice-info"
            type={NotificationType.Important}
            text={t(
              'containers.deposit_money.topup_tab.form.payment.email_invoice_notification'
            )}
          />
        </Box>
      )}
      {anyDeferredCardOrders &&
        paymentMethod === PaymentMethods.CompanyAccount && (
          <Box mt={2}>
            <Notification
              id="load-benefit-page-warning"
              type={NotificationType.Important}
              text={
                <Trans
                  i18nKey={
                    'containers.deposit_money.topup_tab.form.payment.load_benefit_page_warning'
                  }
                  components={{
                    bold: <SemiBold />
                  }}
                />
              }
            />
          </Box>
        )}
      {!!benefitType &&
        !isLunchTopupRequest &&
        paymentMethod === Payment.EInvoice &&
        scheduleType === Schedule.Direct && (
          <Box mt={2}>
            <Notification
              type={NotificationType.Important}
              text={
                benefitType === BenefitType.lunch ? (
                  <Trans i18nKey="containers.deposit_money.topup_tab.form.payment.eInvoice_notification.lounari" />
                ) : (
                  <Trans i18nKey="containers.deposit_money.topup_tab.form.payment.eInvoice_notification.default" />
                )
              }
            />
          </Box>
        )}
    </>
  );
};
